import { render, staticRenderFns } from "./chart-rtp.vue?vue&type=template&id=31f871b3"
import script from "./chart-rtp.vue?vue&type=script&lang=js"
export * from "./chart-rtp.vue?vue&type=script&lang=js"
import style0 from "./chart-rtp.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/stats/chart-rtp.vue
// module id = xV6H
// module chunks = 0